import { useState } from "react";
import Header from "./components/Header";
import Calculator from "./components/Calculator";

const App = () => {
  const [darkMode, setDarkMode] = useState(true);

  return (
    <div
      className={`relative flex flex-col items-center justify-center min-h-screen overflow-x-hidden pb-5 ${
        darkMode ? "bg-gray-900 text-gray-200" : "bg-gray-200 text-gray-900"
      }`}
    >
      <div
        style={{
          background: `radial-gradient(circle at top left, rgba(20, 110, 160, 0.25), transparent 55%), 
                 radial-gradient(circle at bottom right, rgba(120, 19, 161, 0.25), transparent 55%)`,
        }}
        className="absolute inset-0 z-0"
      >
        <Header darkMode={darkMode} setDarkMode={setDarkMode} />
        <div className="flex flex-row items-center justify-center w-full p-10 h-full">
          <Calculator darkMode={darkMode} />
        </div>
      </div>
    </div>
  );
};

export default App;
